import { cloneDeep } from '@apollo/client/utilities';
import { EntityInput, forCreate, forDelete, forUpdate } from '../common/entity';
import { CompanyRelationService, IntegrationSettings } from './integrationSettings';

export class IntegrationSettingsInput extends IntegrationSettings implements EntityInput<IntegrationSettings> {
  forCreate() {
    return this;
  }

  forUpdate() {
    return this;
  }

  forDelete(): DeleteIntegrationSettingsInput {
    return {
      id: this.id,
      version: this.version,
      companyId: this.companyId,
    } as DeleteIntegrationSettingsInput;
  }

  withId(id: string) {
    this.id = id;
    return cloneDeep(this);
  }

  withType(type: CompanyRelationService) {
    this.type = type;
    return cloneDeep(this);
  }

  withName(name: string) {
    this.name = name;
    return cloneDeep(this);
  }

  // SAP
  withPlantId(id: string) {
    this.plantId = id;
    this.externalId = id;
    return cloneDeep(this);
  }

  withUrl(url: string) {
    this.url = url;
    return cloneDeep(this);
  }

  withApiKey(key: string) {
    this.apiKey = key;
    return cloneDeep(this);
  }

  // Business Central
  withTenantId(id: string) {
    this.tenantId = id;
    return cloneDeep(this);
  }

  withEnvironment(environment: string) {
    this.environment = environment;
    return cloneDeep(this);
  }

  withClientId(clientId: string) {
    this.clientId = clientId;
    return cloneDeep(this);
  }

  withClientSecret(clientSecret: string) {
    this.clientSecret = clientSecret;
    return cloneDeep(this);
  }

  withExternalCompanyId(externalCompanyId?: string) {
    this.externalCompanyId = externalCompanyId;
    return cloneDeep(this);
  }

  withExternalInfo(externalInfo?: string) {
    this.externalInfo = externalInfo;
    return cloneDeep(this);
  }

  withUserId(userId?: string) {
    this.userId = userId;
    return cloneDeep(this);
  }
}

export class CreateIntegrationSettingsInput extends forCreate(IntegrationSettings) {}

export class UpdateIntegrationSettingsInput extends forUpdate(IntegrationSettings) {}

export class DeleteIntegrationSettingsInput extends forDelete(IntegrationSettings) {}
